/** Profils de performance appliqués au rendu, aux effets et à l'enregistrement. */

export type PerformanceProfileName = 'low' | 'medium' | 'high';

export interface PerformanceProfile {
  name: PerformanceProfileName;
  /** Plafond du devicePixelRatio appliqué au renderer. */
  maxPixelRatio: number;
  /** Nombre de particules du système d'énergie. */
  particleCount: number;
  /** Ombres temps réel (coûteuses sur mobile). */
  shadows: boolean;
  /** Halo lumineux additif autour de la canette. */
  halo: boolean;
  /** Les particules sont mises à jour toutes les N frames. */
  particleUpdateEveryNFrames: number;
  /** Largeur max du canvas composite d'enregistrement. */
  recordingMaxWidth: number;
  /** FPS cible du flux d'enregistrement. */
  recordingFps: number;
}

export const PROFILES: Record<PerformanceProfileName, PerformanceProfile> = {
  low: {
    name: 'low',
    maxPixelRatio: 1,
    particleCount: 40,
    shadows: false,
    halo: false,
    particleUpdateEveryNFrames: 3,
    recordingMaxWidth: 720,
    recordingFps: 24,
  },
  medium: {
    name: 'medium',
    maxPixelRatio: 1.5,
    particleCount: 120,
    shadows: false,
    halo: true,
    particleUpdateEveryNFrames: 2,
    recordingMaxWidth: 960,
    recordingFps: 30,
  },
  high: {
    name: 'high',
    maxPixelRatio: 2,
    particleCount: 250,
    shadows: true,
    halo: true,
    particleUpdateEveryNFrames: 1,
    recordingMaxWidth: 1280,
    recordingFps: 30,
  },
};
